import { render } from "./BlockLinkApp.vue?vue&type=template&id=5f07da52"
import script from "./BlockLinkApp.vue?vue&type=script&lang=js"
export * from "./BlockLinkApp.vue?vue&type=script&lang=js"

import "./BlockLinkApp.vue?vue&type=style&index=0&id=5f07da52&lang=sass"

import exportComponent from "/home/runner/work/robocleaner/robocleaner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__